import React, { FunctionComponent } from 'react';

type SummaryFieldLabelProps = {
  children?: React.ReactNode;
  'data-test'?: string;
};

const SummaryFieldLabel: FunctionComponent<SummaryFieldLabelProps> = (props) => {
  const { children, ...restProps } = props;

  return (
    <div className="section__content__field-label" {...restProps}>
      {children}
    </div>
  );
};

export default SummaryFieldLabel;
